var map = {
	"./en": [
		"FJnC",
		1
	],
	"./en.ts": [
		"FJnC",
		1
	],
	"./es": [
		"LDuh",
		5
	],
	"./es.ts": [
		"LDuh",
		5
	],
	"./pt": [
		"1C6G",
		1,
		3
	],
	"./pt.ts": [
		"1C6G",
		1,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "12Fk";
module.exports = webpackAsyncContext;